module.exports = __webpack_public_path__ + "static/media/PioLogo.f98c5833.png";